import React from 'react';
import {NavLink} from "react-router-dom";
import { RiUserSettingsLine} from "react-icons/ri";
import {TbChecklist, TbDiscount2, TbHomeHeart} from "react-icons/tb";
import {SlBadge} from "react-icons/sl";

const Navbar = () => {
    return (
        <React.Fragment>
            <nav className="nav nav-pills nav-justified fixed-bottom rtl max-w-lg bg-white nav-bar-app">
                <NavLink className="nav-item nav-link  " to="/home">
                    <div><TbHomeHeart  className='nav-icon' /></div>
                    <span className="text-small-2 ">خانه</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/discounts">
                    <div><TbDiscount2  className='nav-icon' /></div>
                    <span className="text-small-2 ">تخفیفها</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/orders">
                    <div><TbChecklist  className='nav-icon' /></div>
                    <span className="text-small-2 ">سفارشها</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/scores">
                    <div><SlBadge  className='nav-icon' /></div>
                    <span className="text-small-2 ">امتیازمن</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/profile">
                    <div><RiUserSettingsLine  className='nav-icon' /></div>
                    <span className="text-small-2 ">پروفایل</span>
                </NavLink>

            </nav>
        </React.Fragment>
    );
};

export default Navbar;
